
import { RevLink } from '@ds/components/Link'

import { MODAL_NAMES } from '@config/constants'
import IllustrationMoneyBagz from '@core/illustrations/IllustrationMoneyBagz.svg'
import IllustrationMoneyBagzSparkles from '@core/illustrations/IllustrationMoneyBagzSparkles.svg'
import { productGoodestFindsFetch } from '@http/endpoints'

import HighlightedPickersList from '../../HighlightedPickersList'
import AsyncModal from '../AsyncModal'

import translations from './HighlightedPickersModal.translations'

const ILLUSTRATIONS = {
  IllustrationMoneyBagz,
  IllustrationMoneyBagzSparkles,
}

export default {
  components: {
    HighlightedPickersList,
    RevLink,
    AsyncModal,
  },
  data() {
    return {
      content: {
        buttons: [],
      },
      selectedPickerId: 0,
    }
  },
  computed: {
    translations: () => translations,
    modalName() {
      return MODAL_NAMES.PRODUCT.HIGHLIGHTED_PICKERS
    },
    modalTitle() {
      return this.content.title
    },
    pickers() {
      return this.content.buttons.map((picker, index) => ({
        ...picker,
        isSelected: index === this.selectedPickerId,
      }))
    },
    selectedPicker() {
      return {
        id: this.selectedPickerId,
      }
    },
    selectedPickerIllustration() {
      const img = this.content.buttons[this.selectedPickerId]?.image ?? null

      return ILLUSTRATIONS[img]
    },
    selectedPickersParagraphs() {
      return this.content.buttons[this.selectedPickerId]?.paragraphs ?? null
    },
    productId() {
      return this.$route.params.uuid
    },
  },
  methods: {
    async fetchGoodestFinds() {
      const { payload } = await this.$store.dispatch('http/request', {
        request: productGoodestFindsFetch,
        pathParams: { productId: this.productId },
      })

      this.content = { ...payload }
    },
    setSelectedPickerId(selectedPickerId) {
      this.selectedPickerId = selectedPickerId
    },
    handlePickersClick(index) {
      this.setSelectedPickerId(index)
    },
  },
}
